module.exports = __webpack_public_path__ + "static/media/29FUNOV12.53b73664.jpg";